export default __webpack_public_path__ + "static/Montserrat-ExtraBoldItalic-6849a97dd651acfb619a8ae7da5dce96.ttf";